import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const H2 = ({ children }) => (
  <h2 className="mt-10 font-head text-xl font-bold text-white md:text-2xl">{children}</h2>
);
export const P = ({ children }) => (
  <p className="mt-4 font-sans text-sm leading-relaxed text-white/70">{children}</p>
);
export const UL = ({ children }) => (
  <ul className="mt-4 list-disc space-y-2 pl-5 font-sans text-sm leading-relaxed text-white/70">{children}</ul>
);

export const LegalLayout = ({ title, updated, children, testid }) => (
  <div className="relative z-10 min-h-screen" data-testid={testid}>
    <header className="border-b border-white/10 bg-[#05070f]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5">
          <img src="/cyvr-logo.png" alt="CYVR" className="h-9 w-9 object-contain drop-shadow-[0_0_10px_rgba(0,240,255,0.5)]" />
          <span className="font-head text-sm font-bold tracking-tight text-white">CYVR<span className="text-cyber-cyan"> LABS</span></span>
        </Link>
        <Link to="/" className="inline-flex items-center gap-2 font-mono-tech text-xs uppercase tracking-widest text-white/60 transition-colors hover:text-cyber-cyan">
          <ArrowLeft className="h-4 w-4" /> Inicio
        </Link>
      </div>
    </header>

    <main className="mx-auto max-w-4xl px-5 py-16 md:px-8 md:py-24">
      <p className="font-mono-tech text-[11px] uppercase tracking-[0.28em] text-cyber-cyan">Legal</p>
      <h1 className="mt-4 font-head text-4xl font-bold tracking-tight text-white md:text-5xl">{title}</h1>
      {updated && <p className="mt-3 font-mono-tech text-xs text-white/40">Última actualización: {updated}</p>}
      <div className="mt-4">{children}</div>

    </main>
  </div>
);
